import { useTranslation } from "react-i18next";
import { useBiometricSetup } from "core/hooks/useBiometricSetup";
import { StatusModal } from "shared/UI/StatusModal/StatusModal";

interface BiometricLoginModalProps {
  isVisible: boolean;
  onDismiss: () => void;
}

export const BiometricLoginModal = ({ isVisible, onDismiss }: BiometricLoginModalProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "accountSecurity.home.biometric.setup" });
  const { loading, setupAction, responseData } = useBiometricSetup(isVisible);

  if (!isVisible || loading || !responseData) {
    return null;
  }

  return (
    <StatusModal
      data={{
        title: t("title", { status: responseData.success ? setupAction : "error" }),
        description: responseData.message ?? "",
        cta: t("cta"),
      }}
      status={responseData.success ? "success" : "error"}
      handleConfirm={onDismiss}
    />
  );
};
